import * as actionTypes from '../../action/clients/Clients'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: ''
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_CLIENT_FETCH:
            return {
                ...state,
                isFetching: true
            };
        case actionTypes.GET_CLIENT_SUCCESS :
            return {
                ...state,
                isFetching: false,
                error: false,
                clients: action.payload
            };
        
        case actionTypes.GET_CLIENT_FAILURE :
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_CLIENT_MESSAGE:
            return {
                ...state,
                isFetching: false,
                error: false,
                errormessage: action.payload
            };
        case actionTypes.DONE:
            return {
                ...state,
                isFetching: false,
                clients: state.clients
            }
        
        default:
            return state;
    }
}

export default reducer;